<template>
  <div class="filter-wrapper">
    <a-form :model="filterData">
      <div class="df">
        <a-form-item label="任务ID" style="margin-right: 20px;">
          <a-input
            v-model:value="filterData.taskId"
            style="width: 180px"
            @change="initList"
            placeholder="请输入任务ID"
          />
        </a-form-item>
        <!-- <a-form-item label="直播间" name="liveId">
          <a-select
            v-model:value="filterData.liveId"
            placeholder="请选择直播间"
            allow-clear
            style="width: 150px"
            @change="selectLiveRoom"
          >
            <a-select-option
              v-for="(item, index) in liveRoomSelect"
              :key="index"
              :value="item['id']"
              :label="item['chatGroupName']"
            >
              {{ item['chatGroupName'] }}
            </a-select-option>
          </a-select>
        </a-form-item> -->
        <a-form-item label="任务类型" style="margin-right: 20px;">
          <a-select
            ref="select"
            v-model:value="filterData.taskType"
            style="width: 180px"
            allow-clear
            @change="initList"
            placeholder="请选择"
          >
            <a-select-option :value="1" key="浏览任务">
              浏览任务
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="展示类型" style="margin-right: 20px;">
          <a-select
            ref="select"
            v-model:value="filterData.showType"
            style="width: 180px"
            allow-clear
            @change="initList"
            placeholder="请选择"
          >
            <a-select-option :value="1" key="icon">icon</a-select-option>
          </a-select>
        </a-form-item>
        <div class="btn-wrapper">
          <a-button class="mr10" type="primary" @click="initList"
            >查询</a-button
          >
          <a-button @click="resetFilter">重置</a-button>
        </div>
      </div>
    </a-form>
  </div>
</template>

<script>
import { inject, toRefs } from 'vue'
export default {
  setup() {
    return {
      ...toRefs(inject('initState'))
    }
  }
}
</script>

<style lang="scss" scoped>
.filter-wrapper {
  margin-bottom: 10px;
}
.btn-wrapper {
  margin-left: auto;
}
</style>
